export default __webpack_public_path__ + "static/media/0003.93445657.png";